import type { Direction } from "../../direction";
import type { PointsToDirection } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export class ArrowDisplay extends PhysicalThing implements PointsToDirection {
	static key = "ArrowDisplay";
	private direction: Direction | null;

	constructor(xy: XY, direction: Direction | null = null) {
		super(xy, false);
		this.direction = direction;
	}

	getDirection(): Direction | null {
		return this.direction;
	}

	setDirection(direction: Direction): void {
		this.direction = direction;
	}

	getZOrder(): number {
		return ZOrder.TOP;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			direction: this.direction,
		};
	}

	static deserialize(data: any): ArrowDisplay {
		const a = new ArrowDisplay(deserializeXY(data.xy), data.direction ?? null);
		a.visualId = data.visualId;
		return a;
	}
}
